<ac-nav class="flexItem">
    <ng-content logo select="[logo]"></ng-content>
    <ng-content menu select="[menu]"></ng-content>


    <ng-container *ngFor="let navPromise of ((acNavAutoService.navs[0] | acFunc : getChildren) | filterNavs:1: acNavAutoService.changes)" first>
        <ac-nav-button *ngIf="navPromise | async as nav"
                       [attr.id]="'nav-first-' + nav.path"
                       [acDisableLink]="rlaF.isActive"
                       [routerLink]="nav.path | routeBuilder:true"
                       #rlaF="routerLinkActive"
                       routerLinkActive="active"
                       class="first">
            {{ nav | acFunc : getTitle }}
        </ac-nav-button>
    </ng-container>

    <ng-container *ngFor="let navPromise of (acNavAutoService.navs[1] | acFunc : getChildren) | filterNavs:2: acNavAutoService.changes" secondary>
        <ac-nav-button *ngIf="navPromise | async as nav"
                       [attr.id]="'nav-secondary-' + nav.path"
                       [acDisableLink]="rlaS.isActive || ((nav.children | filterNavs:3: acNavAutoService.changes) || []).length>0 && !nav.data?.navAutoNoDropdown"
                       [dropdown]="((nav.children | filterNavs:3: acNavAutoService.changes) || []).length > 0 && !nav.data?.navAutoNoDropdown"
                       [parentClass]="nav.path"
                       [routerLink]="acNavAutoService.navs[1] | routeBuilder:true:nav.path"
                       #rlaS="routerLinkActive"
                       routerLinkActive="active"
                       class="secondary">

            {{ nav | acFunc : getTitle }}

            <ng-container *ngFor="let thirdPromise of nav.children | filterNavs:3: acNavAutoService.changes" dropdown-option>
                <div *ngIf="thirdPromise | async as third"
                     [attr.id]="'nav-third-'+third.path"
                     [routerLink]="acNavAutoService.navs[1] | routeBuilder:true: nav.path : third.path"
                     routerLinkActive="active"
                     class="dropdown-option">
                    {{ third.data && (third | acFunc : getTitle) }}
                </div>
            </ng-container>
        </ac-nav-button>
    </ng-container>

    <div *ngIf="acNavAutoService.navs[1]?.data.secondNavText" secondary>
        <div class="secondary-text">{{ acNavAutoService.navs[1]?.data.secondNavText }}</div>
    </div>
</ac-nav>
